var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavMenuLinkRidm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.608 17L31 21.392v6.216L26.608 32h-6.216L16 27.608v-6.216L20.392 17h6.216zM14 18c.552 0 1 .448 1 1v11c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V19c0-.552.448-1 1-1h11zm12.194 0h-5.389L17 21.805v5.389L20.806 31h5.387L30 27.193v-5.387L26.194 18zM14 19H3v11h11V19zM8.5 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm21.784.028c.552 0 1 .448 1 1 0 .173-.045.343-.13.493L24.37 14.493c-.272.48-.882.65-1.363.377-.157-.09-.288-.22-.377-.377L15.846 2.52c-.272-.48-.103-1.09.377-1.363.15-.085.32-.13.493-.13h13.568zm0 1H16.716L23.5 14l6.784-11.972z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuLinkRidm);
export default __webpack_public_path__ + "static/media/nav-menu-link-ridm.8642a3994aaccb0cd9719804d41bc110.svg";
export { ForwardRef as ReactComponent };